export default '8FAB6';
